<template>
    <div class="flex-column">
        <!-- FILTER SEARCHBAR -->
        <div v-if="activeSearchBar" class="form-group mb-2 p-0 fs-3">
            <div class="form-input wp-10">
                <input
                    ref="searchfilter"
                    v-model="searchKeyword"
                    type="text"
                    class="h-4 wp-10"
                    :placeholder="searchPlaceholder"
                />
            </div>
        </div>
        <!-- FILTER SEARCHBAR END -->
        <div class="big-item-list bb-1">
            <div v-if="!!options.length" class="form-group">
                <input
                    id="checkUncheck"
                    v-model="allselected"
                    type="checkbox"
                    name="checkUncheck"
                />
                <label for="checkUncheck">
                    {{
                        choices.length === Object.values(options).length
                            ? $l10n.__('Tout décocher')
                            : $l10n.__('Tout cocher')
                    }}
                </label>
            </div>

            <template v-for="option in options" :key="option.value">
                <div class="form-group">
                    <label class="form-label label-auto" :for="'opt-' + option.value">
                        <input
                            :id="'opt-' + option.value"
                            v-model="choices"
                            type="checkbox"
                            name="options[]"
                            :value="`${option.value}`"
                            @change="handleCheckedOption($event.target.checked, option.options)"
                        />
                        {{ option.label }}
                    </label>

                    <template
                        v-for="subOption in orderOptionsByRank(option.options)"
                        :key="subOption.value"
                    >
                        <div class="form-group ml-4">
                            <label class="form-label label-auto" :for="'subopt-' + subOption.value">
                                <input
                                    :id="'subopt-' + subOption.value"
                                    v-model="subChoices"
                                    type="checkbox"
                                    name="subOption[]"
                                    :value="subOption.value"
                                    @change="handleCheckedSubOption(`${option.value}`)"
                                />
                                {{ subOption.label }}
                            </label>
                        </div>
                    </template>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';
import { removeAccents } from 'Core/commons/Utilities';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            choices: [],
            subChoices: [],
            searchKeyword: '',
        };
    },
    computed: {
        // Used in Mixin
        /* eslint-disable-next-line vue/no-unused-properties */
        data() {
            return {
                choices: this.choices,
                subChoices: this.subChoices,
            };
        },
        options() {
            if (this.filter.name === 'staffsgroup') {
                let sortedOptions = Object.values(this.filter.inputs.choices.options).sort((a, b) =>
                    b.value - a.value > 0 ? 1 : -1,
                );
                const otherOption = sortedOptions.find((item) => item.value === 0);
                if (otherOption) {
                    sortedOptions = sortedOptions.filter(
                        (item) => item.value !== otherOption.value,
                    );
                    sortedOptions.push(otherOption);
                }
                return sortedOptions;
            }

            return Object.values(this.filter.inputs.choices.options)
                .map((choice) => {
                    let checkbox = choice;
                    if (!this.activeSearchBar || !this.searchKeyword.length) return checkbox;

                    // Yep, sometimes options is an object...
                    const options =
                        typeof choice.options === 'object'
                            ? Object.keys(choice.options).map((key) => choice.options[key])
                            : choice.options;
                    const keywords = removeAccents(this.searchKeyword.toLowerCase());
                    const subOption = options.filter((sub) =>
                        removeAccents(sub.label.toLowerCase()).includes(keywords),
                    );
                    if (
                        !removeAccents(choice.label.toLowerCase()).includes(keywords) &&
                        !subOption.length
                    ) {
                        checkbox = false;
                    }

                    if (!!subOption.length) {
                        checkbox =
                            typeof checkbox.options === 'object'
                                ? { ...checkbox, options: { ...subOption } }
                                : { ...checkbox, options: [...subOption] };
                    }

                    return checkbox;
                })
                .filter((choice) => !!choice)
                .sort((a, b) => (b.rank - a.rank < 0 ? 1 : -1));
        },

        allselected: {
            get() {
                return Object.values(this.options).length === this.choices.length;
            },
            set() {
                this.toggleCheckAll();
            },
        },

        noneselected() {
            return !this.choices.length;
        },

        activeSearchBar() {
            return ['sourcecatid', 'funnelid'].includes(this.filter.name);
        },

        searchPlaceholder() {
            let label;
            switch (this.filter.name) {
                case 'sourcecatid':
                    label = this.$l10n.__('Rechercher une source');
                    break;
                case 'funnelid':
                    label = this.$l10n.__('Rechercher une pipeline');
                    break;
                default:
                    label = this.$l10n.__('Rechercher un filtre');
                    break;
            }

            return label;
        },
    },

    watch: {
        choices() {
            const cb = document.getElementById('checkUncheck');
            cb.indeterminate = !this.allselected && !this.noneselected;
        },
    },
    mounted() {
        Object.values(this.choices).forEach((option, index) => {
            this.handleCheckedSubOption(this.choices[index]);
        });
    },

    methods: {
        toggleCheckAll() {
            if (this.choices.length === Object.values(this.options).length) {
                this.choices = [];
                this.subChoices = [];
            } else {
                this.choices = [];
                Object.values(this.options).forEach((option) => {
                    this.choices.push(parseInt(option.value, 10));

                    Object.values(option.options).forEach((subOption) => {
                        this.subChoices.push(subOption.value);
                    });
                });
            }

            Object.values(this.options).forEach((option) => {
                const field = document.getElementById('opt-' + option.value);
                field.indeterminate = false;
            });
        },

        handleCheckedOption(checked, subOptions) {
            Object.values(subOptions).forEach((option) => {
                if (checked) {
                    if (!this.subChoices.includes(option.value)) {
                        this.subChoices.push(option.value);
                    }
                } else {
                    const index = this.subChoices.indexOf(option.value);
                    if (index !== -1) this.subChoices.splice(index, 1);
                }
            });
        },

        handleCheckedSubOption(parentValue) {
            if (!parentValue) {
                return;
            }

            const parent = Object.values(this.options).find(
                (option) => option.value.toString() === parentValue,
            );
            let countAllSubOptionsParent = 0;
            let countSubOptionsSelected = 0;

            Object.values(parent.options).forEach((subOption) => {
                countAllSubOptionsParent++;
                if (this.subChoices.includes(subOption.value)) {
                    countSubOptionsSelected++;
                }
            });

            const field = document.getElementById('opt-' + parentValue);
            field.indeterminate = false;

            if (countAllSubOptionsParent === countSubOptionsSelected) {
                // add parent in this.choices
                if (!this.choices.includes(parentValue)) {
                    this.choices.push(parentValue);
                }
            } else if (countSubOptionsSelected === 0) {
                // remove parent from this.choices + remove indeterminate
                const index = this.choices.indexOf(parentValue);
                if (index !== -1) this.choices.splice(index, 1);
            } else if (countAllSubOptionsParent > countSubOptionsSelected) {
                // add parent from this.choices + add indeterminate
                if (!this.choices.includes(parentValue)) {
                    this.choices.push(parentValue);
                }
                field.indeterminate = true;
            }
        },

        orderOptionsByRank(options) {
            return Object.values(options).sort((a, b) => (b.rank - a.rank < 0 ? 1 : -1));
        },
    },
};
</script>
<style>
.big-item-list {
    overflow-y: auto;
}
</style>
